import GameFull from './GameFull'
import { NEGATIVE } from '../constants/games'

const NegativePage = () => GameFull(NEGATIVE)

export default NegativePage